import { z } from 'zod';

/**
 * Mapping type enum for field mappings
 * TODO: Update with actual values from backend when available
 */
export enum FieldMappingType {
    Direct = 0,
    Constant = 1,
    Transform = 2,
}

/**
 * Zod schema for BusinessDocTypeFieldMapping form validation
 */
export const BusinessDocTypeFieldMappingFormSchema = z.object({
    Id: z.number().int(),
    BusinessDocTypeMappingId: z.number().int(),
    SourceListXPath: z.string().nullable(),
    TargetListXPath: z.string().nullable(),
    SourceXPath: z.string().nullable(),
    TargetXPath: z.string().nullable(),
    MappingType: z.number().int(),
    MappingType_US: z.string().nullable(),
    ConstantValue: z.string().nullable(),
    TransformationExpr: z.string().nullable(),
    CreatedTime: z.union([z.string(), z.date()]).optional(),
    LastUpdateDate: z.union([z.string(), z.date()]).optional(),
});

/**
 * Form data type for field mappings (used in UI forms)
 */
export type BusinessDocTypeFieldMappingFormData = z.infer<typeof BusinessDocTypeFieldMappingFormSchema>;

/**
 * BusinessDocTypeFieldMappingViewModel
 * Full API response type including server-generated fields
 */
export interface BusinessDocTypeFieldMappingViewModel {
    Id: number;
    BusinessDocTypeMappingId: number;
    SourceListXPath: string | null;
    TargetListXPath: string | null;
    SourceXPath: string | null;
    TargetXPath: string | null;
    MappingType: number;
    MappingType_US: string;
    ConstantValue: string | null;
    TransformationExpr: string | null;
    /** Server-managed */
    CreatedTime?: string | Date;
    /** Server-managed */
    LastUpdateDate?: string | Date;
}
